"use client";

import { Form } from "react-aria-components";

import type { useFlightSearchForm } from "./hooks/use-flight-search-form";
import { FlightSearch } from "./flight-search";

export type StatelessFlightSearchFormProperties = ReturnType<
  typeof useFlightSearchForm
>;
export const StatelessFlightSearchForm = ({
  bestFareFinderBaseUrl,
  bookingUrl = "https://www.jetblue.com/booking/flights",
  errors,
  formList,
  labels,
  odQuery,
  onTripTypeChange,
  passengers,
  showDatePickerPricing,
  showPromoCode,
  formReference,
  handleSubmit,
  tripType,
}: StatelessFlightSearchFormProperties) => (
  <Form
    action={bookingUrl}
    className="p-4"
    data-fs-element="booker"
    onSubmit={handleSubmit}
    ref={formReference}
    validationBehavior="aria"
  >
    <FlightSearch
      bestFareFinderBaseUrl={bestFareFinderBaseUrl}
      errors={errors}
      formList={formList}
      labels={labels}
      odQuery={odQuery}
      onTripTypeChange={onTripTypeChange}
      passengers={passengers}
      showDatePickerPricing={showDatePickerPricing}
      showPromoCode={showPromoCode}
      tripType={tripType}
    />

    <div className="hidden">
      <input
        name="isMultiCity"
        readOnly
        value={tripType === "multi-city" ? "true" : "false"}
      />
      <input
        name="noOfRoute"
        readOnly
        value={
          tripType === "multi-city" ? formList.routes.length.toString() : "1"
        }
      />
      <input name="roundTripFaresFlag" readOnly value="false" />
      <input name="sharedMarket" readOnly value="false" />
      <input name="usePoints" readOnly value={formList.usePoints.toString()} />
    </div>
  </Form>
);
